import {NavigationBackground, SkinTheme, UIType} from "../@const";
import { GoodDayUserInterface } from "../ui";
import UI_Layout from "../../layout/ui-layout";
import NavigationPanel_Classic_User from "./navigation-panel/user";


export class GoodDayTop extends GoodDayUserInterface {

    constructor() {
        super({
            type        : UIType.TOP
        })
    }


    // Navigation Panel

    get NavigationPanelUserComponent():any {
        return NavigationPanel_Classic_User
    }

    get navbarButtonSize() {
        return 50;  // 38px button-size + 12px margin right
    }

    get navigationPanelMainClass() {

        let classes = "ui-navigation top-nav"

        let navigationColorTheme : NavigationBackground = gd.user.settings.skin.navigation

        switch (gd.skin.layoutTheme) {
            case SkinTheme.DARK:
                classes += ' theme-dark-'+ navigationColorTheme
                break

            case SkinTheme.LIGHT:
            default:
                classes += ' theme-light-'+ navigationColorTheme
                break
        }

        return classes
    }


    // End




    get layoutCSSClass():string {
        return "ui-layout top-nav"
    }

    get LayoutClass() {
        return UI_Layout
    }



    get hasContrastSettings():boolean {
        return this.isLight
    }
}
